// import {useState} from 'react'
import cn from 'clsx'
import {Checkbox, Switch, InputNumber, Input} from 'antd'

import styles from './RequestLoanForm.module.scss'
import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
// import {BrokerForm, useGetBrokers} from 'modules/users'
import {PROJECT_CATEGORY_NAME, ProjectCategory} from 'modules/project'
import {
  useWatch,
  Box,
  Button,
  Form,
  FormItem,
  // ButtonLink,
  // Select,
  // Modal,
  Text,
  RangePicker,
  InputAmount,
} from 'common/components'
import {useInputFocus} from 'common/hooks'
import {FIELD_RULES} from 'common/constants'
import {RequestTabFormProps} from '..'

export default function RequestLoanForm({
  newRequest,
  form,
  clickedTab,
  isRequestCreating,
  setNewRequest,
  setTab,
  setClickedTab,
  onClose,
}: RequestTabFormProps) {
  const role = useStore((state) => state.role)
  const brokerHelpValue = useWatch('brokerHelp', form)
  const inputRef = useInputFocus()
  const isNotManager = (!role.manager && !role['associated-manager'])

  const handleFinish = ({brokerHelp, /*brokerProfile,*/ ...values}: any) => {
    setNewRequest({
      ...newRequest,
      ...values,
      // brokerProfile: brokerProfile ?? null,
      loanFormSubmit: true,
    })
    setTab(clickedTab)
  }

  const handleSubmitClick = () => setClickedTab('documents')

  const initialValues = {
    loanValueRequested: newRequest.loanValueRequested,
    dates: newRequest.dates,
    categories: newRequest.categories,
    units: newRequest.units,
    brokerHelp: role.user ? newRequest.brokerHelp : undefined,
    brokerName: role.user ? newRequest.brokerName : undefined,
    brokerEmail: role.user ? newRequest.brokerEmail : undefined,
    brokerPhoneNumber: role.user ? newRequest.brokerEmail : undefined,
  }

  return (
    <Form
      className={styles.form}
      form={form}
      initialValues={initialValues}
      onFinish={handleFinish}
    >
      <FormItem
        name="loanValueRequested"
        label="Borrowing amount, $ nzd"
        rules={FIELD_RULES}
      >
        <InputAmount ref={inputRef} />
      </FormItem>
      <FormItem
        name="dates"
        label="Estimated project dates"
        rules={FIELD_RULES}
      >
        <RangePicker disablePast />
      </FormItem>
      <Text weight="demiBold">Purpose</Text>
      <FormItem
        noStyle
        name="categories"
        label="Choose at least one of the below"
        rules={FIELD_RULES}
      >
        <Checkbox.Group>
          {projectCategoryOptions.map((item) => (
            <Checkbox key={item.value} value={item.value}>
              {item.label}
            </Checkbox>
          ))}
        </Checkbox.Group>
      </FormItem>
      <FormItem
        className={styles.halfField}
        name="units"
        label="Number of units"
        rules={FIELD_RULES}
      >
        <InputNumber min={1} />
      </FormItem>
      {/* {role.user ? (
        <>
          <FormItem name="brokerName" label="Broker's name">
            <Input />
          </FormItem>
          <FormItem name="brokerEmail" label="Broker's email">
            <Input type="email" />
          </FormItem>
        </>
      ) : role.broker ? (
        <>
          <FormItem
            name="borrowerName"
            label="Borrower's name"
            rules={FIELD_RULES}
          >
            <Input />
          </FormItem>
          <FormItem
            name="borrowerEmail"
            label="Borrower's email"
            rules={FIELD_RULES}
          >
            <Input type="email" />
          </FormItem>
        </>
      ) : (
        <>
          <FormItem
            className={cn(
              styles.switchField,
              brokerHelpValue && styles.switchField_on
            )}
            name="brokerHelp"
            label="Does the broker help to create the request?"
            valuePropName="checked"
          >
            <Switch />
          </FormItem>
          {brokerHelpValue && <SelectBroker />}
        </>
      )} */}
      { isNotManager &&
      <div className={cn(styles.inline)}>
        <Text size="md" weight='demiBold'>
          Did a Broker assist with this request?
        </Text>
        <FormItem
          noStyle
          className={cn(
            styles.switchField,
            brokerHelpValue && styles.switchField_on
          )}
          name="brokerHelp"
          label=""
          valuePropName="checked"
          labelCol={{ span: 24 }}
        >
          <Switch />
        </FormItem>
      </div>
      }
      {brokerHelpValue && <BrokerInfo />}

      <Box align="right">
        <Button
          className={cn(
            commonStyles.button,
            'Button_type_form',
            'Button_type_form_cancel',
          )}
          loading={isRequestCreating}
          onClick={onClose}
        >
          Cancel
        </Button>
        &nbsp;
        <Button
          className={cn(
            commonStyles.button,
            'Button_type_form',
            'Button_type_form_submit',
          )}
          htmlType="submit"
          loading={isRequestCreating}
          onClick={handleSubmitClick}
        >
          Next
        </Button>
      </Box>
    </Form>
  )
}

const BrokerInfo = () => (
  <Box mb={48}>
    <FormItem name="brokerName" label="Broker name" rules={FIELD_RULES}>
      <Input />
    </FormItem>
    <FormItem name="brokerEmail" label="Broker Email" rules={FIELD_RULES}>
      <Input />
    </FormItem>
    <FormItem name="brokerPhoneNumber" label="Broker phone number" rules={FIELD_RULES}>
      <Input />
    </FormItem>
  </Box>
)

// const SelectBroker = () => {
//   const {data: brokers, isLoading} = useGetBrokers()
//   const [isSelectOpen, setSelectOpen] = useState(false)
//   const [isModalOpen, setModalOpen] = useState(false)

//   const handeSelectOpenSet = (open: boolean) => setSelectOpen(open)

//   const handleModalOpen = () => {
//     setSelectOpen(false)
//     setModalOpen(true)
//   }

//   const handleModalClose = () => setModalOpen(false)

//   const brokerOptions = brokers
//     ? brokers.map((broker) => ({
//         value: broker.uuid,
//         label: (
//           <div className={styles.broker}>
//             <p>{broker.title}</p>
//             <Text color="grey" size="xs" ml={12}>
//               #{broker.licenceNumber}
//             </Text>
//           </div>
//         ),
//         textLabel: broker.title,
//       }))
//     : []

//   return (
//     <FormItem
//       name="brokerProfile"
//       label="Assign broker or invite via email"
//       rules={FIELD_RULES}
//     >
//       <Select
//         showSearch
//         placeholder="Search broker"
//         optionFilterProp="textLabel"
//         loading={isLoading}
//         options={brokerOptions}
//         open={isSelectOpen}
//         dropdownRender={(menu) => (
//           <>
//             {menu}
//             <>
//               <Box pl={14} mt={12}>
//                 <ButtonLink onClick={handleModalOpen}>
//                   Add new broker…
//                 </ButtonLink>
//               </Box>
//               <Modal
//                 title="Add new broker"
//                 open={isModalOpen}
//                 onCancel={handleModalClose}
//               >
//                 <BrokerForm onClose={handleModalClose} />
//               </Modal>
//             </>
//           </>
//         )}
//         onDropdownVisibleChange={handeSelectOpenSet}
//       />
//     </FormItem>
//   )
// }

const projectCategoryOptions = (
  Object.keys(PROJECT_CATEGORY_NAME) as ProjectCategory[]
).map((value: ProjectCategory) => ({
  value,
  label: PROJECT_CATEGORY_NAME[value],
}))
